import { IDeveloper } from "@types";
import { BaseAPI } from "@utils";

class DeveloperApi extends BaseAPI<IDeveloper> {}

export const developerApi = new DeveloperApi("/api/v1/developer");
